<template>
    <div class="backpage" @click="goBack">
   
        ← 返回上一级
    </div>
    <div class="installt">
        <div class="intext">会员信息详情</div>
        <div class="installts">
            <div class="addpoper2" @click="prohibitUser(usermInfo.closeStatus)"> {{ usermInfo.closeStatus == 0 ? '解封账号'
        :
        '封禁账号'
                }} </div>
            <div class="dropdown">
                <div class="addpoper">
                    <div style="height: 24px;margin-right: 6px;">账号提权</div>
                    <div>
                        <el-icon :size="24" color="#fff">
                            <CaretBottom style=" margin-right: 8px" />
                        </el-icon>
                    </div>
                </div>
                <div class="dropdown-content">
                    <div class="dropdowns" @click="authority(item.value)" v-for="(item, index) in Privilge"
                        :key="index">{{
        item.name }}</div>
                </div>
            </div>

        </div>

    </div>
    <div class="pmassage">
        <div class="pmassagel">
            <div class="usermes">
                <div class="userh">
                    <div class="userhs">
                        <img :src="headeeface(usermInfo.uuserface || '')" alt="">
                        <!-- <img src="../../assets/shop/morentx.png" alt=""> -->
                    </div>
                    <div class="username">
                        <div>{{ usermInfo.uusername || usermInfo.uid }}</div>
                        <div>{{ identitys }} &nbsp; {{ hehuor(usermInfo.isPartner) }}</div>
                    </div>
                </div>
                <div class="huamoney">
                    <div>{{ usermInfo.huaGuo || 0 }}</div>
                    <div>花果</div>
                </div>
                <div class="huamoney">
                    <div>{{ usermInfo.huaFen || 0 }}</div>
                    <div>花粉</div>
                </div>
                <div class="huamoney">
                    <div>{{ usermInfo.huaHua || 0 }}</div>
                    <div>花花</div>
                </div>
                <div class="huamoney">
                    <div>{{ usermInfo.menbi || 0 }}</div>
                    <div>余额</div>
                </div>
            </div>
            <div class="usermessage">
                <div class="usera">
                    <div class="usermst">基本信息</div>
                    <!-- <div class="bian">
                        <div>编号</div>
                        <div>12312412313</div>
                    </div> -->
                    <div class="bian">
                        <div>账户ID</div>
                        <div>{{ usermInfo.uid }}</div>
                    </div>
                    <div class="bian">
                        <div>账户状态</div>
                        <div>{{ usermInfo.closeStatus == 0 ? '已封禁' : '正常' }}</div>
                    </div>
                    <div class="bian">
                        <div>注册时间</div>
                        <div> {{ datahuan(usermInfo.uregdate) }}</div>
                    </div>
                </div>
                <div class="usera">
                    <div class="usermst">认证信息</div>
                    <div class="bian">
                        <div>真实姓名</div>
                        <div>{{ usermInfo.urealname || '暂无' }}</div>
                    </div>
                    <div class="bian">
                        <div>身份证号</div>
                        <div>{{ usermInfo.idNumber || '暂无' }}</div>
                    </div>
                    <div class="bian">
                        <div>联系人</div>
                        <div>{{ '暂无' }}</div>
                    </div>
                    <div class="bian">
                        <div>手机号</div>
                        <div>{{ usermInfo.utel || '暂无' }}</div>
                    </div>
                </div>
                <div class="usera">
                    <div class="usermst">推荐人信息</div>
                    <div class="bian">
                        <div>推荐人姓名：</div>
                        <div @click="openDialog">{{ usermInfo.refereeName || '暂无' }} <el-icon color="#0091FF">
                                <EditPen />
                            </el-icon></div>
                    </div>
                    <div class="bian">
                        <div>身份证号：</div>
                        <div>{{ '暂无' }}</div>
                    </div>
                    <div class="bian">
                        <div>推荐人ID:</div>
                        <div>{{ usermInfo.refereeId || '暂无' }}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="pmassager">
            <div class="dmoney">
                <div class="huat">
                    <div>冻结金额</div>
                </div>
                <div class="addmessage">
                    <div class="addtext">余额（已冻结{{ usermInfo.freezeTotalAmount || 0 }}元）</div>
                    <div class="addinput">
                        ￥
                        <input type="number" v-model="freezeAmounts" placeholder="0.00" min="0">
                        <!-- <input type="number" v-if="usermInfo.freezeTotalAmount > 0" v-model="freezeAmounts"
                            placeholder="0.00" min="0" disabled> -->

                    </div>
                    <div class="yidong">可以冻结余额({{ usermInfo.menbi - usermInfo.freezeTotalAmount || 0 }})元,已经冻结了{{
        usermInfo.freezeTotalAmount || 0 }}
                    </div>

                </div>
                <div class="iss">
                    <div class="isdong" @click="freeze(1)"> 冻结 </div>
                    <div class="isdong" @click="freeze(2)"> 解冻 </div>

                </div>

            </div>
            <div class="huac">
                <div class="huat">
                    <div>助花充值</div>
                </div>
                <div class="addmessage">
                    <div class="addtext">花花</div>
                    <div class="addinput">
                        ￥<input type="number" v-model="huaHua" placeholder="0.00" min="0">
                    </div>
                    <div class="addtext">花粉</div>
                    <div class="addinput">
                        ￥<input type="number" v-model="huaFen" placeholder="0.00" min="0">
                    </div>
                    <div class="addtext">花果</div>
                    <div class="addinput">
                        ￥<input type="number" v-model="huaGuo" placeholder="0.00" min="0">
                    </div>
                    <div class="baochun" @click="zhuRecharge" style="cursor: pointer;">保存</div>

                </div>
            </div>
        </div>
    </div>
    <yc-mask ref="maskRef" :close-on-click-modal="false">
        <div class="dialog">
            <div class="dialogt">
                <div>
                    修改推荐人
                </div>
                <div @click="closeDialog">
                    <el-icon>
                        <Close />
                    </el-icon>
                </div>
            </div>
            <div class="nowgroom">
                <div>
                    <div>{{ usermInfo.refereeName || '暂无' }}</div>
                    <div>门铃号: {{ usermInfo.refereeId || '暂无' }}</div>
                </div>
                <div>现有推荐人</div>
            </div>
            <div class="search">
                <div style="width: 24px;height: 24px;margin-right: 14px;">
                    <el-icon size="24">
                        <Search />
                    </el-icon>
                </div>
                <div>
                    <input type="text" placeholder="搜索推荐人id" v-model="referenceid" @keyup.enter="referenceList">
                </div>
            </div>
            <div class="nextgroom">
                <div class="rooms" v-for="(item, index) in references" :key="index">
                    <div class="userh">
                        <div class="userhs">
                            <img style="width: 100%;height: 100%;" :src="headeeface(item.uuserface)" alt="">
                        </div>
                        <div class="username">
                            <div>{{ item.uusername }}</div>
                            <div>{{ item.uid }}</div>
                        </div>
                    </div>
                    <div class="norooms" @click="updateReference(item.uid)"
                        :style="{ 'pointer-events': item.uid == usermInfo.refereeId ? 'none' : 'auto' }">
                        {{ updateReferenc(item) }}
                    </div>
                </div>

            </div>
        </div>
    </yc-mask>
</template>

<script setup>
import ycMask from '@/components/mask/mask.vue'
import { onMounted, ref } from 'vue';
import api from '@/api/api';
import { useRoute, useRouter } from 'vue-router';
import { ElMessage, ElMessageBox } from 'element-plus'
// import { fi } from 'element-plus/es/locale';
// import {  } from 'element-plus'

const route = useRoute()
const router = useRouter()
const { userId, identity } = route.query
const usermInfo = ref({})
const identitys = ref('')
let huaFen = ref(null)
let huaGuo = ref(null)
let huaHua = ref(null)
let referenceid = ref('')
let references = ref([])
let Privilge = ref([

])
const hehuor = (hehuors) => {
    if (hehuors) {
        if (hehuors == 200) {
            return '村店合伙人'
        } else if (hehuors == 150) {
            return '镇配合伙人'

        } else if (hehuors == 100) {
            return '区县合伙人'
        }
    } else {
        return ''
    }

}
const Privilgech = () => {
    console.log('identity', identity)
    let Privilges = [
        {
            name: '普通会员',
            value: '1'
        },
        {
            name: '助花SVIP会员',
            value: '2'
        },
        {
            name: '村店合伙人',
            value: '200'
        },
        {
            name: '镇配合伙人',
            value: '150'
        },
        {
            name: '区县合伙人',
            value: '100'
        }

    ]
    if (identity == 1) {
        Privilges.splice(0, 1)
    } else if (identity == 2) {
        Privilges.splice(1, 1)
    }
    if (usermInfo.value.isPartner == 200) {
        Privilges.splice(2, 1)

    } else if (usermInfo.value.isPartner == 150) {
        Privilges.splice(3, 1)

    } else if (usermInfo.value.isPartner == 100) {
        Privilges.splice(4, 1)

    }
    Privilge.value = Privilges
}
onMounted(() => {
    identitys.value = (identity == 1 ? '普通会员' : '助花会员')
    memberInfo()
    Privilgech()

})
const memberInfo = async () => {
    try {
        const res = await api.memberInfo(userId, identity)
        usermInfo.value = res.data
        console.log(usermInfo.value)

    } catch (error) {
        console.log(error)
    }
}

const headeeface = (face) => {

    if (face) {
        const regex = /"(.*?)"/;
        const result = face.match(regex);
        // 输出提取的字符
        if (result && result[1]) {
            if (result[1].startsWith('http')) {
                return result[1]
            } else {
                if (result[1].startsWith('/')) {
                    return 'http://www.daomenkou.cn' + result[1]

                } else {
                    return 'http://www.daomenkou.cn/' + result[1]

                }
            }
        } else {
            console.log('未找到匹配的字符串');

            if (face.startsWith('http')) {
                return face
            } else {
                return 'http://www.daomenkou.cn/' + face
            }
        }
    } else {
        return require('../../assets/shop/morentx.png')
    }

}
let freezeAmounts = ref(null)

let freezeShaw = async (data) => {
    const res = await api.freezeShaw(data)
    console.log(res.data)
    if (res.success) {
        router.go(0)
    }
}
const freeze = (freezeTotalAmount) => {


    let freezeAmount
    let freezeId
    let operateTypes

    if (freezeTotalAmount == 2) {
        if (freezeAmounts.value < 1 || freezeAmounts.value == null) {
            ElMessage.error('金额必须大于零!')

        } else if (freezeAmounts.value > usermInfo.value.freezeTotalAmount) {
            ElMessage.error('金额必须小于冻结金额!')

        }
        else {
            freezeAmount = freezeAmounts.value
            freezeId = userId
            operateTypes = 2
            let data = {
                freezeAmount,
                freezeId,
                freezeType: 2,
                operateType: operateTypes
            }
            ElMessageBox.confirm('是否要解冻该账号金额?')
                .then(() => {
                    // console.log(222)
                    // delAdmin(true)
                    freezeShaw(data)
                })
                .catch(() => {
                    // catch error
                    console.log(22333)
                })
        }

    } else {
        if (freezeAmounts.value < 1 || freezeAmounts.value == null) {
            ElMessage.error('金额必须大于零!')
        } else if (freezeAmounts.value > usermInfo.menbi) {
            ElMessage.error('金额必须小于余额!')
        }
        else {
            freezeAmount = freezeAmounts.value
            freezeId = userId
            operateTypes = 1
            let data = {
                freezeAmount,
                freezeId,
                freezeType: 1,
                operateType: operateTypes
            }
            ElMessageBox.confirm('是否要冻结该账号金额?')
                .then(() => {
                    // console.log(222)
                    // delAdmin(true)
                    freezeShaw(data)


                })
                .catch(() => {
                    // catch error
                    console.log(22333)
                })
        }

    }

}
const authority = (value) => {
    console.log(value)
    ElMessageBox.confirm('是否要修改该账号会员?')
        .then(() => {
            // console.log(222)
            // delAdmin(true)
            authoritys(value)
        })
        .catch(() => {
            // catch error
            console.log(22333)
        })

}

const authoritys = async (value) => {
    let data = {
        authorityType: value,
        userId
    }
    const res = await api.authority(data)
    console.log(res)
    if (res.success) {
        router.go(0)
    }
}

const zhuRecharge = async () => {
    let data = {
        userId: userId,
        huaFen:  Number(huaFen.value) ,
        huaGuo:  Number(huaGuo.value),
        huaHua:  Number(huaHua.value) 
    }
    if (huaFen.value < 0 || huaGuo.value < 0 || huaHua.value < 0) {
        ElMessage.error('充值金额必须大于零!')
    } else if (huaFen.value < 1 && huaGuo.value < 1 && huaHua.value < 1) {
        ElMessage.error('至少充值一项金额充值金额')

    } else {
        const res = await api.zhuRecharge(data)
        console.log(res)
        if (res.success) {
            ElMessage({
                message: '充值成功！',
                type: 'success',
                duration: '800',
                onClose: () => {
                    router.go(0)
                }
            })
        } else {
            ElMessage.error('充值失败！')
        }
    }

}
const prohibitUser = async (isBan) => {
    if (isBan == 0) {
        ElMessageBox.confirm('是否要解封该账号?')
            .then(() => {
                // console.log(222)
                delAdmin(false)
            })
            .catch(() => {
                // catch error
                console.log(22333)
            })
    } else {
        ElMessageBox.confirm('是否要封禁该账号?')
            .then(() => {
                // console.log(222)
                delAdmin(true)
            })
            .catch(() => {
                // catch error
                console.log(22333)
            })
    }


}
const delAdmin = async (isBan) => {
    console.log(userId)
    let data = {
        isBan,
        userId
    }

    // let userId = userId
    const res = await api.prohibitUser(data)
    console.log(res)
    if (res.success) {
        ElMessage({
            message: '操作成功',
            type: 'success',
            duration: '800',
            onClose: () => {
                router.go(0)
            }
        })
    } else {
        ElMessage.error('修改失败!')
    }
}
const updateReference = async (id) => {
    let data = {
        referenceId: id,
        userId: userId,
        referenceType: identity
    }
    const res = await api.updateReference(data)
    console.log(res)
    if (res.success) {
        ElMessage({
            message: '修改成功！',
            type: 'success',
        })
    } else {
        ElMessage.error('修改失败!')
    }
}
const updateReferenc = (item) => {
    console.log(item.uid, usermInfo.value.refereeId)
    if (item.uid == usermInfo.value.refereeId) {
        return '现有推荐人'
    } else {
        return '修改推荐人'
    }
}
const referenceList = async () => {
    const res = await api.referenceList(referenceid.value)
    references.value = res.data.members
    console.log(references)

}
const datahuan = (days) => {
    if (days) {
        const date = new Date(days)
        const year = date.getFullYear()
        const month = date.getMonth() + 1
        const day = date.getDate()
        return `${year}-${month}-${day}`
    } else {
        return ''
    }

}
const goBack = () => {
    window.history.back();
}
//获取遮罩的实例
let maskRef = ref(null);
//打开弹窗
let openDialog = () => {
    maskRef.value.showMask();
};

//关闭弹窗
let closeDialog = () => {
    maskRef.value.closeMask();
};
</script>

<style lang="scss" scoped>
.backpage {
    margin-top: -20px;
    font-size: 16px;
    color: #3F8CFF;
    cursor: pointer;
}

.installt {
    width: 1164px;
    display: flex;
    height: 52px;
    justify-content: space-between;
    align-items: center;

    .intext {
        font-size: 36px;
        font-weight: 400;
        color: #0A1629;
    }

    .installts {
        display: flex;

        .dropdown {
            position: relative;
            display: inline-block;

            .addpoper {
                width: 120px;
                height: 52px;
                background: rgba(63, 140, 255);
                box-shadow: 0px 6px 12px 0px rgba(63, 140, 255, 0.26);
                border-radius: 8px;
                color: #FFFFFF;

                padding-left: 16px;
                box-sizing: border-box;
                display: flex;
                align-items: center;
            }

            .dropdown-content {
                display: none;
                position: absolute;
                background-color: #f9f9f9;
                min-width: 120px;
                box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
                cursor: pointer;
                border-radius: 8px;

                .dropdowns {
                    height: 50px;
                    text-align: center;
                    line-height: 50px;
                    color: #0091FF;
                }

                :hover {
                    background-color: #f1f1f1
                }

            }
        }

        .dropdown:hover .dropdown-content {
            display: block;
        }



        .addpoper2 {
            width: 120px;
            height: 52px;
            background: rgba(63, 140, 255);
            box-shadow: 0px 6px 12px 0px rgba(63, 140, 255, 0.26);
            border-radius: 8px;
            color: #FFFFFF;
            text-align: center;
            line-height: 52px;
            box-sizing: border-box;
            margin-right: 15px;
            cursor: pointer;

        }
    }

}

.pmassage {
    margin-top: 19px;
    height: calc(100% - 20px - 52px - 14px);
    display: flex;

    .pmassagel {
        width: 820px;
        background: #FFFFFF;
        height: 100%;
        border-radius: 8px;
        margin-right: 17px;
        padding: 33px 0 0 28px;
        box-sizing: border-box;

        .usermes {
            display: flex;
            padding-left: 20px;
            box-sizing: border-box;
            font-size: 14px;
            font-weight: 400;
            color: #0A1629;
            height: 56px;

            .userh {
                display: flex;

                width: 234px;
                margin-right: 80px;

                .userhs {
                    width: 56px;
                    height: 56px;
                    border-radius: 28px;
                    background-color: #d4d0d0;
                    margin-right: 10px;
                    overflow: hidden;

                    img {
                        width: 100%;
                        height: 100%;
                    }
                }

                .username {
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;


                }




            }

            .huamoney {
                width: 50px;
                padding-top: 14px;
                box-sizing: border-box;
                text-align: center;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                margin-right: 73px;
            }
        }

        .usermessage {
            display: flex;
            justify-content: space-between;
            margin-top: 72px;
            box-sizing: border-box;
            padding: 0 30px 0 12px;

            .usera {
                .usermst {
                    font-size: 18px;
                    font-weight: 400;
                    color: #0A1629;
                    margin-bottom: 20px;

                }

                .bian {
                    font-size: 14px;
                    font-weight: 500;
                    color: rgba(0, 0, 0, 0.88);
                    margin-bottom: 29px;

                    div:last-child {
                        font-size: 12px;
                        margin-top: 8px;

                        color: #667076;
                    }
                }
            }
        }
    }

    .pmassager {
        width: 334px;
        height: 100%;

        .dmoney {
            height: 262px;
            border-radius: 8px;
            background: #FFFFFF;

            .huat {
                height: 54px;
                display: flex;
                align-items: center;
                border-bottom: 1px solid rgba(151, 151, 151, 0.12);
                padding: 0 28px 0 34px;
                font-size: 18px;
                font-weight: 400;
                color: #0091FF;
            }

            .addmessage {
                padding: 20px 30px 0 34px;

                .addtext {
                    height: 22px;
                    font-size: 14px;
                    color: #0A1629;
                    margin-bottom: 5px;
                }

                .addinput {
                    width: 252px;
                    height: 45px;
                    background: #FAFAFA;
                    border-radius: 8px;
                    padding: 0 0 0 16px;
                    display: flex;
                    align-items: center;
                    margin-bottom: 5px;


                    input {
                        width: 252px;

                        height: 16px;
                        border: none;
                        outline: none;
                        font-size: 14px;
                        background: #FAFAFA;
                    }
                }

                .yidong {
                    font-size: 12px;
                    font-weight: 400;
                    color: #0091FF;
                    text-align: right;
                }
            }

            .iss {
                width: 268px;
                margin: 0 auto;
                display: flex;
                justify-content: space-around;

                .isdong {
                    font-size: 14px;
                    font-weight: 400;
                    color: #0091FF;
                    margin: 24px auto;
                    width: 40%;
                    height: 45px;
                    border: 2px solid #0091FF;
                    border-radius: 8px;
                    text-align: center;
                    line-height: 41px;
                    box-sizing: border-box;
                    cursor: pointer;
                }

                // .isdong:hover {
                //     background-color: rgb(63, 140, 255);
                //     color: #FFFFFF;
                //     border-color: #FAFAFA;
                // }
            }



        }

        .huac {
            margin-top: 11px;
            height: calc(100% - 273px);
            background: #FFFFFF;
            border-radius: 8px;
            box-sizing: border-box;

            .huat {

                height: 54px;
                display: flex;
                align-items: center;
                border-bottom: 1px solid rgba(151, 151, 151, 0.12);
                padding: 0 28px 0 34px;
                font-size: 18px;
                font-weight: 400;
                color: #0091FF;
                justify-content: space-between;
            }

            .addmessage {
                padding: 20px 30px 0 34px;

                .baochun {
                    font-size: 14px;
                    font-weight: 400;
                    color: #0091FF;
                    margin: 24px auto;
                    width: 268px;
                    height: 45px;
                    border: 2px solid #0091FF;
                    border-radius: 8px;
                    text-align: center;
                    line-height: 41px;
                    box-sizing: border-box;
                    cursor: pointer;
                }

                .baochun:hover {
                    background-color: rgb(63, 140, 255);
                    color: #FFFFFF;
                    border-color: #FAFAFA;
                }

                .addtext {
                    height: 22px;
                    font-size: 14px;
                    color: #0A1629;
                    margin-bottom: 5px;
                }

                .addinput {
                    width: 252px;
                    height: 45px;
                    background: #FAFAFA;
                    border-radius: 8px;
                    padding: 0 0 0 16px;
                    display: flex;
                    align-items: center;
                    margin-bottom: 15px;


                    input {
                        width: 252px;

                        height: 16px;
                        border: none;
                        outline: none;
                        font-size: 14px;
                        background: #FAFAFA;
                    }
                }
            }


        }

    }
}

.dialog {
    position: relative;
    width: 380px;
    height: 608px;
    background: #FFFFFF;
    border-radius: 8px;
    padding: 23px 36px 0 35px;

    .dialogt {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 18px;
        font-weight: 600;
        color: rgba(0, 0, 0, 0.88);
        margin-bottom: 20px;
    }

    .nowgroom {
        width: 100%;
        height: 58px;
        background: #F2F8FC;
        border-radius: 8px;
        display: flex;
        justify-content: space-between;
        padding: 0 13px;
        align-items: center;
        box-sizing: border-box;

        div:last-child {
            font-size: 14px;
            font-weight: 400;
            color: rgba(0, 0, 0, 0.88);
        }
    }

    .search {
        width: 100%;
        height: 48px;
        margin-right: 24px;
        background: #F8F8F8;
        box-shadow: 0px 6px 58px 0px rgba(196, 203, 214, 0.1);
        border-radius: 8px;
        display: flex;
        align-items: center;
        margin: 14px auto;
        padding-left: 20px;
        box-sizing: border-box;

        input {
            width: 300px;
            border: none;
            outline: none;
            font-size: 16px;
            background: #F8F8F8;

        }

    }

    .nextgroom {
        .rooms {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 20px;

            .userh {
                display: flex;
                width: 234px;
                margin-right: 80px;

                .userhs {
                    width: 56px;
                    height: 56px;
                    border-radius: 28px;
                    background-color: #d4d0d0;
                    margin-right: 10px;

                }

                .username {
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                }
            }

            .norooms {
                width: 102px;
                height: 40px;
                text-align: center;
                line-height: 40px;
                border-radius: 8px;
                border: 1px solid #0291FE;
                font-size: 16px;
                font-weight: 400;
                color: #0091FF;
                cursor: pointer;
            }
        }
    }


}
</style>